import { useState } from "react";
import { Form, Dropdown } from "react-bootstrap";
import { useTranslation } from "react-i18next";

interface SelectCustomProps<T> {
    options: { value: T; label: string; icon?: string }[];
    selectedValue: T;
    onChange: (value: T) => void;
    width?: string;
}

const SelectCustom = <T,>({ options, selectedValue, onChange, width = "12rem" }: SelectCustomProps<T>) => {

    const { i18n, t } = useTranslation();
    const isRtl = i18n.language === 'he';
        
    return (
            <div style={{ width }}> {/* Fixed width wrapper */}
                <Dropdown>
                    <Dropdown.Toggle variant="outline-secondary" className="dropdown-custom">
                        {options.find((opt) => opt.value === selectedValue)?.icon && (
                            <i className={options.find((opt) => opt.value === selectedValue)?.icon} style={{ marginRight: 8, verticalAlign: "inherit" }}></i>
                        )}
                        {options.find((opt) => opt.value === selectedValue)?.label || t('select')}
                    </Dropdown.Toggle>
                    <Dropdown.Menu className="w-100">
                        {options.map((option) => (
                            <Dropdown.Item key={String(option.value)} onClick={() => onChange(option.value)} style={{ textAlign: isRtl ? 'right' : 'left' }}>
                                {option.icon && <i className={option.icon} style={{ marginRight: 8, verticalAlign: "middle" }}></i>}
                                {option.label}
                            </Dropdown.Item>
                        ))}
                    </Dropdown.Menu>
                </Dropdown>
            </div>
        
    );

};

export default SelectCustom;